// ** I18n Imports
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "@/assets/locales/en.json";
import translationTR from "@/assets/locales/tr.json";
import { loadAppSettings, defaultSetting } from "@/configs/appSetting";

// Önce default dil ile başlat
i18n.use(initReactI18next).init({
  lng: defaultSetting.InitialLanguage,
  resources: {
    en: { translation: translationEN },
    tr: { translation: translationTR },
  },
  fallbackLng: "en",
  debug: false,
  react: { useSuspense: false },
  interpolation: { escapeValue: false, formatSeparator: "," },
});

loadAppSettings().then((s) => {
  if (s.InitialLanguage && s.InitialLanguage !== i18n.language) {
    i18n.changeLanguage(s.InitialLanguage);
  }
});

export default i18n;
